var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternal3List(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Internal_3_List"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Internal_3_List",
    "data-name": "Internal 3_List",
    clipPath: "url(#clip-Internal_3_List)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_664",
    "data-name": "Ellipse 664",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(1 1)",
    fill: "#0071cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20395",
    "data-name": "Group 20395",
    transform: "translate(5.986 5.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20388",
    "data-name": "Group 20388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32843",
    "data-name": "Path 32843",
    d: "M0,43.014a1.381,1.381,0,0,1,.289-.645,1.284,1.284,0,0,1,.968-.483c.583-.021,1.166,0,1.749-.008a.5.5,0,0,1,.37.125.448.448,0,0,1,.109.488.442.442,0,0,1-.413.282q-.867,0-1.734,0a.451.451,0,0,0-.269.079.44.44,0,0,0-.185.385q0,1.023,0,2.046,0,1.119,0,2.238a.442.442,0,0,0,.486.488H5.647a.437.437,0,0,0,.483-.481q0-.842,0-1.685a.44.44,0,0,1,.377-.455.447.447,0,0,1,.509.362,1.177,1.177,0,0,1,.011.161c0,.526,0,1.051,0,1.577a1.357,1.357,0,0,1-.417,1.047,1.262,1.262,0,0,1-.891.361h-4.4A1.318,1.318,0,0,1,.013,47.82c0-.017-.008-.035-.013-.052V43.014",
    transform: "translate(0 -41.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32844",
    "data-name": "Path 32844",
    d: "M132.914,3.169a.456.456,0,0,1-.36.331.441.441,0,0,1-.523-.427c0-.485,0-.969,0-1.454V1.53c-.038.008-.054.036-.074.056L128.43,5.1a.446.446,0,1,1-.673-.586c.024-.027.05-.052.075-.077L131.326.956l.059-.062A.131.131,0,0,0,131.3.882h-1.457a.444.444,0,0,1-.222-.828A1.237,1.237,0,0,1,129.739,0h2.852a.514.514,0,0,1,.324.323Z",
    transform: "translate(134.674 6.122) rotate(180)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternal3List);
export default __webpack_public_path__ + "static/media/Internal 3_List.89e7d3f92297f22b79aca699ab7b74f0.svg";
export { ForwardRef as ReactComponent };